import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import ModuleSwitcher from "@/components/ModuleSwitcher";
import { Toaster } from "sonner";

export default function Layout() {
  return (
    <div className="min-h-screen flex bg-slate-100/60">
      <Sidebar />
      <main className="flex-1 min-w-0 flex flex-col" data-testid="app-main">
        {/* Top brand bar — workspace switcher on the left, SVRAF logo on the right */}
        <div
          className="flex items-center justify-between h-20 px-6 bg-white border-b border-slate-200 shrink-0 gap-4"
          data-testid="brand-topbar"
        >
          <ModuleSwitcher />
          <img
            src="/svraf-logo-sm.png"
            alt="SVRAF"
            className="h-14 w-auto object-contain"
            data-testid="svraf-brand-logo"
          />
        </div>
        <div className="flex-1 min-h-0">
          <Outlet />
        </div>
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
}
